import VendorsTable from './VendorsTable'
export default VendorsTable
